const PopularData = [

    {
        id: 19,
        name: "Chocolate Ice Cream",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 21,
        quantity : 1,
        rating: 5,
        preprice: "",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/chocolate-ice-cream-dessert_144627-8363.jpg?t=st=1654021235~exp=1654021835~hmac=9b373d5f0695bf7976867710d69845cc7a5f8f4484b2d6868ce7df3133a9157a&w=826",
      },
      {
            image: "https://img.freepik.com/free-photo/ice-cream-cone_144627-41497.jpg?t=st=1654889259~exp=1654889859~hmac=87242439c775f68064a293a6deb8cbe23becce466ba5d50dee9b082c36a358c0&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-homemade-ice-cream-scoops-concept_23-2148425380.jpg?t=st=1654889310~exp=1654889910~hmac=fbacb7be231b700ddaef9114b9533bf89571d179a17375f97241df08c0cb23db&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/ice-cream-with-bananas-chocolate-sprinkles-white-plate_114579-33759.jpg?t=st=1654889401~exp=1654890001~hmac=7fb9105f6717da2d2886c995299c5a5df7217d9821c830807cea0e85b607013b&w=740",
},
      ],
    },





    {
        id: 17,
        name: "Traditional Sushi",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 33,
        rating: 3,
        quantity : 1,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
        sale: "",
        
        images: [
            {
                image: "https://img.freepik.com/free-photo/traditional-sushi-dark-surface_1150-42063.jpg?t=st=1654020709~exp=1654021309~hmac=18828f5b829cdefbdc331c2e507ee5cacc9cd447f822010e66e8dab95978cfa0&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],
    },
   



    {
        id: 15,
        name: "Cheese Pizza",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 32,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "pizza",
        Image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/traditional-supreme-pizza-rustic-wooden-table_123827-20264.jpg?t=st=1654021593~exp=1654022193~hmac=2d5955bc39647a52766d496b74e66602764516189faed64b84cac8f752a3993e&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/pizza-time-tasty-homemade-traditional-pizza-italian-recipe_144627-42535.jpg?t=st=1654887749~exp=1654888349~hmac=fffca468b13e99b32aa97de4be03aa77d262519b5c7192554c4fd3bf0e95ee1a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/pizza-margarita-wooden-board-cheese-dough-crackers-top-view_141793-15507.jpg?t=st=1654887805~exp=1654888405~hmac=491ec32d8c752aae90c23e5561520167e23530c24c786cea99b02a97a51a0688&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/delicious-italian-pizza-wooden-table_23-2148643432.jpg?t=st=1654887865~exp=1654888465~hmac=40627796212a68368f2ced52c4bd4c563a5fd2a0ceb553684da27d2d3793d2e6&w=740",
},
      ],

    },
    



    {
        id: 14,
        name: "Fruits salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 12,
        quantity : 1,
        rating: 4,
        preprice: "",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/top-view-delicious-fruit-salad-inside-plate-with-fresh-fruits-gray-fruit-tree-exotic-tropical-photo-ripe-diet_140725-109945.jpg?t=st=1654020292~exp=1654020892~hmac=7b29995dd7eeccabfc6467fb6ae3fe191d06fb4432e600d909edbb67180db4ab&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },

    {
        id: 13,
        name: "Russian salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 23,
        rating: 4,
        quantity : 1,
        preprice: "20$",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
        sale: "SALE ON",

        images: [
            {
                image: "https://img.freepik.com/free-photo/salad-with-tuna-tomatoes-potato-onion_2829-10301.jpg?t=st=1654020292~exp=1654020892~hmac=5fac5ecd6e6573ff14240bd1a4081de086dd39956d3bcedb7deaa1f9f1465a5f&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },








    {
        id: 12,
        name: "Beaf Burger",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 46,
        rating: 3,
        quantity : 1,
        preprice: "",
        category: "burger",
        Image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
        sale: "",
        images: [
            {
                image: "https://img.freepik.com/free-photo/chicken-burger-wooden-board-side-view_141793-2753.jpg?t=st=1654000347~exp=1654000947~hmac=ba3050dcdafc6a516a27a90c676c524253807dc30f951b0c45f7e865bb8bc9a3&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-cheese-salad-tomatoes-dark-floor_140725-89524.jpg?t=st=1654886481~exp=1654887081~hmac=9e9810df343229aa7622633701ae9879692a6a34834fc40533f363c007b51d85&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/front-view-tasty-meat-burger-with-cheese-salad-dark-background_140725-89597.jpg?t=st=1654886481~exp=1654887081~hmac=93903dc66cb652942002ca6ba8d62b9e162f54bca89ab34ed5fa2c23d9da6d7a&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/front-view-meat-burger-with-salad-cheese-tomatoes-dark-background_140725-89540.jpg?t=st=1654886662~exp=1654887262~hmac=7e069bdaf83a2b5da4ad951fa85788912a7006753b4c271ed8ed2e335193812f&w=740",
},
      ],
    },




    {
        id: 10,
        name: "Chocolate cake",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 22,
        rating: 5,
        quantity : 1,
        preprice: "",
        category: "desert",
        Image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
        sale: "",

        images: [
            {
                image: "https://img.freepik.com/free-photo/front-view-sweet-chocolate-cake_23-2148834059.jpg?t=st=1654021012~exp=1654021612~hmac=b385af82d89fb8acbd77c635bc6853c34565033021c38c9a45f8d303a735e1f1&w=900",
      },
      {
            image: "https://img.freepik.com/free-photo/sponge-cake-with-strawberries-top_144627-45517.jpg?t=st=1654889048~exp=1654889648~hmac=2401a3a76cb5174dab4308210a31609252f7e0381ec605f6b8d12e862969e71c&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/assortment-pieces-cake_114579-28298.jpg?t=st=1654889048~exp=1654889648~hmac=e0f48369eefeaa89e954ec6f3dac8a179a3bf872fd385b06f720d7c42b4fda75&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/stunning-birthday-cake-covered-with-pink-icing-roses_8353-1076.jpg?t=st=1654889048~exp=1654889648~hmac=51e0b8842f21bd8981ad8fa2406f10145b170fe8e0454af69e1c3808c29476d9&w=740",
},
      ],
    },





    {
        id: 9,
        name: "chicken salad",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 15,
        rating: 3,
        quantity : 1,
        preprice: "20$",
        category: "salat",
        Image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
        sale: "SALE ON",

        images: [
            {
                image: "https://img.freepik.com/free-photo/salad-chicken-breast-with-zucchini-cherry-tomatoes_2829-8505.jpg?t=st=1653944564~exp=1653945164~hmac=2713898100f68d20187f4ad4d28f8306d6a1bc504eddd83e4abc900a6c157511&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/side-view-delicious-vegetarian-meal-plate-purple-stripped-towel-dark-background_140725-130417.jpg?t=st=1654888690~exp=1654889290~hmac=f8978389ef98f1f0c3a75d26325860c2897892362634fe0961be0fa7384a05aa&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/top-view-salad-with-different-ingredients-dark-plate_23-2148537175.jpg?t=st=1654888613~exp=1654889213~hmac=3ababa987f894621db67916f748861486f4499398ec6b223eb24b6735b926076&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/top-view-caesar-salad-oval-grey-plate-green-white-checkered-tablecloth-dark-red-background_140725-124350.jpg?t=st=1654888690~exp=1654889290~hmac=2d7198257959eb570f5daa897e217a9e2776052dcb08493e8fa41c71c9454c24&w=740",
},
      ],
    },




    {
        id: 7,
        name: " philadelphia roll ",
        description: "This impressive paella is a perfect party dish and a fun meal to cook",
        detaildes: "Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu. In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus.",
        price: 36,
        rating: 4,
        quantity : 1,
        preprice: "",
        category: "sushi",
        Image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
        sale: "",


        images: [
            {
                image: "https://img.freepik.com/free-photo/side-view-philadelphia-roll-with-conger-eel-crab-meat-avocado-cucumber-teriyaki-sauce-ginger-wasabi-tray_141793-5046.jpg?t=st=1653945937~exp=1653946537~hmac=5dbf15b3147b7ef13ebbed7909634bcc664f6883a7ed0ad940abdb5253ff608b&w=740",
      },
      {
            image: "https://img.freepik.com/free-photo/close-up-delicious-fresh-sushi-black-plate_482257-24206.jpg?t=st=1654888183~exp=1654888783~hmac=cea80d3df334501bbef964d6e014b27f0a82f736a7438dc5d7220f0cd477c44a&w=740",
      },
{
            image: "https://img.freepik.com/free-photo/korean-food-kim-bap-steamed-rice-with-vegetables-seaweed_1150-42968.jpg?t=st=1654888240~exp=1654888840~hmac=d35d3f72115236c8e81dc729ff4ec133179ab3af8d952f6f0510955675438bb3&w=740",
},
{  
            image: "https://img.freepik.com/free-photo/sushi-set-with-avocado-salmon-crab-sesame-seeds-ginger-wasabi_141793-17598.jpg?t=st=1654888240~exp=1654888840~hmac=d8dbfc1d83163b90d8a3e7271a36bdd4031d940f949226eb3e3f5d5bb50c4da2&w=740",
},
      ],

    },

    

]


export default PopularData;